const PackagesIntro = () => import('@pages/packagesIntro/index')

export const PackagesIntroNav = [
  {
    path: '/packages_intro',
    name: 'PackagesIntro',
    component: PackagesIntro,
    meta: {auth: false}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/packagesIntro.route.js